import { render, staticRenderFns } from "./modal-respuesta.vue?vue&type=template&id=6dadf8df&scoped=true&"
import script from "./modal-respuesta.vue?vue&type=script&lang=js&"
export * from "./modal-respuesta.vue?vue&type=script&lang=js&"
import style0 from "./modal-respuesta.vue?vue&type=style&index=0&id=6dadf8df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dadf8df",
  null
  
)

export default component.exports